export const enum Direction {
  W,
  D
}

export class ClogFactory {
  private constructor() {}
  public static create(
    on: boolean, // calc
    width: number,
    height: number,
    hasDeck: boolean, // 4=true
    num: number, // 2
    clearance: number, // 2
    wBlocks: number, // 4
    dBlocks: number, // 4
    direction: string // w/d
  ): Clog {
    if (!on) {
      return new NullClog()
    }
    const d = direction === 'w' ? Direction.W : Direction.D
    if (hasDeck) {
      return new TwoWayClog(width, height, wBlocks, dBlocks, d)
    }
    return new OneWayClog(width, height, num, clearance, d)
  }
}

export default interface Clog {
  getHeight(): number
}
export class NullClog implements Clog {
  public getHeight(): number {
    return 0
  }
}
export class OneWayClog implements Clog {
  public constructor(
    private readonly width: number,
    private readonly height: number,
    private readonly num: number,
    private readonly clearance: number,
    private readonly direction: Direction
  ) {}
  public getWidth(): number {
    return this.width
  }
  public getHeight(): number {
    return this.height
  }
  public getNum(): number {
    return this.num
  }
  public getClearance(): number {
    return this.clearance
  }
  public getDirection(): Direction {
    return this.direction
  }
}
export class TwoWayClog implements Clog {
  private readonly deckThick: number = 18 // デッキの使用板厚は18mm固定。
  public constructor(
    private readonly width: number,
    private readonly height: number,
    private readonly wBlocks: number,
    private readonly dBlocks: number,
    private readonly direction: Direction
  ) {}
  public getWidth(): number {
    return this.width
  }
  public getHeight(): number {
    return this.height + this.deckThick
  }
  public getDeckThick(): number {
    return this.deckThick
  }
  public getBlockHeight(): number {
    return this.height
  }
  public getWidthBlocks(): number {
    return this.wBlocks
  }
  public getDepthBlocks(): number {
    return this.dBlocks
  }
  public getDirection(): Direction {
    return this.direction
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Order/Components/Three/Clog.ts